import isBadGatewayError from '@ancon/wildcat-utils/error/isBadGatewayError'
import isServiceUnavailableError from '@ancon/wildcat-utils/error/isServiceUnavailableError'
import isTooManyRequestsError from '@ancon/wildcat-utils/error/isTooManyRequestsError'

/**
 * Rejection interceptor for Hangfire status polls.
 *
 * The shared interceptor retries network errors and 423 with a backoff, which
 * keeps the worker waiting while the poller would simply ask again on its next
 * tick, and a status poll's 423 is the job's stored result, which a retry
 * cannot change. So here:
 * - 502, 503 and 429 become a temporary error without a status code: the
 *   poller logs it and polls again, instead of rejecting the worker.
 * - Everything else, 423 and network errors included, goes to the poller
 *   unchanged.
 */
export default function handleHangfireResponseRejection(
  error: any,
): Promise<unknown> {
  if (
    isServiceUnavailableError(error) ||
    isBadGatewayError(error) ||
    isTooManyRequestsError(error)
  ) {
    return Promise.reject(
      new Error(
        `Hangfire status poll answered ${error.response?.status}, polling again`,
      ),
    )
  }

  return Promise.reject(error)
}
